import { useCallback } from 'react';
import { Textarea } from 'tdesign-react';

import { IPhase } from '@/interface';

interface IItemProps {
  value: IPhase[];
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: IPhase[]) => void
}

const Item = (props: IItemProps) => {
  const { value, disabled, onChange } = props;

  const handleChange = useCallback((val: string) => {
    onChange([{ character: val }, ...value.slice(1, -1)]);
  }, []);

  return <Textarea
    style={{ width: '100%' }}
    autosize={{ minRows: 5, maxRows: 5 }}
    placeholder={props.placeholder}
    disabled={disabled}
    value={value[0]?.character || ''}
    onChange={handleChange}
  />;
};

export default Item;
